import React from 'react';
import { Modal, Container, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import CloseIcon from '@mui/icons-material/Close';
import clsx from 'clsx';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    outline: 'none'
  },
  closeButton: {
    position: 'fixed',
    right: theme.spacing.length / 2,
    top: theme.spacing.length / 2,
    color: theme.palette.grey[500]
  },
  fullHeight: {
    height: '100%'
  },
  modalContent: {
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    wordWrap: 'break-word'
  }
}));

export default function(props: any) {
  const classes = useStyles();

  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Container
        component="main"
        className={clsx(classes.paper, classes.fullHeight)}
      >
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={props.onClose}
        >
          <CloseIcon />
        </IconButton>
        <div className={classes.fullHeight}>
          <div className={clsx(classes.modalContent, classes.fullHeight)}>
            {props.children}
          </div>
        </div>
      </Container>
    </Modal>
  );
}
